import { VisitingHoursDepartmentResource } from "app/models/VisitingHoursDepartmentResource";
import { CMSResource } from "app/resources/cmsresource";
import { ClientFaqAndKioskResource } from './ClientFaqAndKioskResource';

export class ClientFaqResource extends CMSResource {
    rid: number;
    questionRo: string;
    questionEn: string;
    questionFr: string;
    questionDe: string

    answerRo: string;
    answerEn: string;
    answerFr: string;
    answerDe: string;

    userEmail: string;
    orderIndex: number;
    kioskResourceList: ClientFaqAndKioskResource[];
    showDelete: boolean = false;
}